export const IMPERIAL_UNITS_LOCALES = ['en-US', 'en-LR', 'my-MM']
